import React, { useEffect, useRef, useState } from "react";
import { TableHead } from "./TableHead";
import { TableBody } from "./TableBody";
import { Thumbnail } from "./Thumbnail";
import { TrHovered } from "./TrHovered";
import { Arrow } from "./Arrow";
import gsap from "gsap";

export const TableContainer = (props) => {
	const { data, columns, onOrderChange, searchBarRef, raz } = props;

	// const [visuel, setVisuel] = useState({});
	const [positionMove, setPositionMove] = useState({});

	const [positionHovered, setPositionHovered] = useState({});
	const [project, setProject] = useState(false);

	const [orderArgs, setOrderArgs] = useState(null);

	const TrMove = (args) => {
		const { e, project } = args;
		const x = e.nativeEvent.layerX;
		const width = e.target.offsetWidth;
		// const visuelsLen = project.visuels.length;
		// const part = width / visuelsLen;
		// const position = parseInt(x / part);
		// const visuel = project.visuels[position];

		// if (visuel) {
		// 	setVisuel(visuel);
		// 	setPositionMove({ x: e.clientX, y: e.clientY });
		// }
	};

	const TrMouseEnter = (args) => {
		const { e, project } = args;
		const target = e.target;
		setProject(project);

		const y = target.getBoundingClientRect().top;

		var doc = document.querySelector(".agence");
		var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
		const yRelativeToDocument = y + top;

		const tdHeight = target.offsetHeight;

		setPositionHovered({
			top: yRelativeToDocument,
			height: tdHeight,
		});
	};
	const TrMouseLeave = (args) => {
		const { e, project } = args;
		// setVisuel({});
		setProject(false);
	};
	const TrMouseClick = (args) => {
		const { e, project } = args;
		// console.log("Click");
		const permalink = project.permalink;
		const isArchive = project.archive;

		if (!isArchive) {
			if (project.permalink_target) {
				window.open(permalink, "_blank");
			} else {
				window.location.href = permalink;
			}
		}
	};
	const ThMouseClick = (args) => {
		// const newArgs =
		// 	args.slug === "categories"
		// 		? { slug: "typologie_visible", sens: args.sens }
		// 		: args;
		setOrderArgs(args);
	};
	useEffect(() => {
		if (orderArgs) {
			onOrderChange(orderArgs);
		}
	}, [orderArgs]);

	const [LinesRef, setLinesRef] = useState([]);
	const TrRef = (refs) => {
		const prevLinesRef = LinesRef;
		refs.map((ref) => {
			prevLinesRef.push(ref);
		});
		setLinesRef(prevLinesRef);
	};
	const TheadRef = (ref) => {
		const prevLinesRef = LinesRef;
		prevLinesRef.push(ref);
		setLinesRef(prevLinesRef);
	};

	if (searchBarRef && Array.isArray(LinesRef)) {
		if (!LinesRef.includes(searchBarRef)) {
			const prevLinesRef = [...LinesRef];
			prevLinesRef.unshift(searchBarRef);
			setLinesRef(prevLinesRef);
		}
	}

	useEffect(() => {
		if (searchBarRef) {
			const Lines = LinesRef.flat();

			const heightLine = Lines[2].offsetHeight;
			const sliceFirst = parseInt(window.innerHeight / heightLine) - 2;
			const tl = gsap.timeline();
			tl.fromTo(
				"#react-root",
				{
					opacity: 0,
				},
				{
					opacity: 1,
					duration: 0.2,
				}
			);
			tl.fromTo(
				Lines.slice(0, sliceFirst),
				{
					opacity: 0,
					y: -10,
					rotateY: "-10deg",
					duration: 0,
					borderBottomColor: "transparent",
				},
				{
					opacity: 1,
					y: 0,
					rotateY: "0deg",

					duration: 0.5,
					borderBottomColor: "#000",

					stagger: {
						amount: sliceFirst * 0.02,
					},
				}
			);
			tl.add(() => {
				setIsVisibleHovered(true);
			});
		}
	}, [searchBarRef]);

	const [IsVisibleHovered, setIsVisibleHovered] = useState(false);

	return (
		<>
			<table>
				<TableHead
					key={1}
					columns={columns}
					ThMouseClick={ThMouseClick}
					TheadRef={TheadRef}
					raz={raz}
				/>
				<TableBody
					projects={data}
					TrMove={TrMove}
					TrMouseEnter={TrMouseEnter}
					TrMouseLeave={TrMouseLeave}
					TrMouseClick={TrMouseClick}
					TrRef={TrRef}
					Visible={IsVisibleHovered}
				/>
			</table>
			{/* <Thumbnail visuel={visuel} position={positionMove} Visible={IsVisibleHovered} /> */}
			<table style={positionHovered} className="table-hovered">
				<TableHead key={2} columns={columns} />
				{project ? (
					<tbody>
						<TrHovered
							project={project}
							position={positionHovered}
							Visible={IsVisibleHovered}
						/>
					</tbody>
				) : (
					""
				)}
			</table>
			<Arrow
				project={project}
				position={positionHovered}
				Visible={IsVisibleHovered}
			/>
		</>
	);
};
